import { Component, OnInit, Inject, Renderer2 } from '@angular/core';
import { Router } from "@angular/router";
import { CommonService } from '@services/app.common.service';

@Component({
    selector: 'app-app-homelayout',
    templateUrl: './app-homelayout.component.html',
    styleUrls: ['./app-homelayout.component.css'],
    standalone: false
})
export class AppHomeLayoutComponent implements OnInit {


  cssloaded = false;
  isProduction = true;
  _baseUrl: string;
  //public _sanitizer;

  constructor(private router: Router, @Inject('BASE_URL') baseUrl: string, private renderer: Renderer2, public common: CommonService) {
    if (!this.common.GetFromLocalStorage('auth_token') || this.common.GetFromLocalStorage('auth_token') == 'null') {
      this.router.navigate(['Login']);
    }
    this._baseUrl = baseUrl;
    this.renderer.removeClass(document.body, 'body-class-login');
    this.renderer.addClass(document.body, 'body-class');
  }

  ngOnInit() {

    if (this.cssloaded == false) {

      this.cssloaded = true;
    }
  }



  stop(element: Event) {
    event?.stopPropagation();
  }

}
